function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.0187 8.96967H33C33 3.30766 29.6413 0 23.9507 0H9.04933C3.35867 0 0 3.30766 0 8.89745V21.1026C0 26.6923 3.35867 30 9.04933 30H23.9507C29.6413 30 33 26.6923 33 21.1026V20.5826H26.0187C22.7786 20.5826 20.152 17.9959 20.152 14.805C20.152 11.6141 22.7786 9.02744 26.0187 9.02744V8.96967ZM26.0186 11.454H31.7679C32.4484 11.454 32.9999 11.9972 32.9999 12.6673V16.8849C32.992 17.5518 32.445 18.0904 31.7679 18.0982H26.1506C24.5103 18.12 23.076 17.014 22.7039 15.4406C22.5176 14.4638 22.7792 13.456 23.4185 12.687C24.0578 11.9181 25.0096 11.4668 26.0186 11.454ZM26.2679 15.8883H26.8106C27.5072 15.8883 28.0719 15.3322 28.0719 14.6461C28.0719 13.9601 27.5072 13.404 26.8106 13.404H26.2679C25.9347 13.4001 25.6139 13.5277 25.3769 13.7584C25.1399 13.9891 25.0066 14.3036 25.0066 14.6317C25.0065 15.3201 25.5689 15.8804 26.2679 15.8883ZM7.81742 8.96964H17.1308C17.8274 8.96964 18.3921 8.4135 18.3921 7.72747C18.3921 7.04143 17.8274 6.48529 17.1308 6.48529H7.81742C7.1265 6.48524 6.56413 7.03263 6.55609 7.71302C6.55604 8.40143 7.11844 8.96173 7.81742 8.96964Z",
  fill: "#9F1F63"
});

function SvgWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.704cde1b.svg";
export { ForwardRef as ReactComponent };